"use client";

import * as stylex from "@stylexjs/stylex";
import type { EpisodeTableRow, LeagueEpisodeTableRow } from "./episode-values";
import { styles } from "./episodes.styles";
import { EpisodeActions } from "./episode-actions";
import { EpisodeResult } from "./episode-result";
import { EpisodeScore } from "./episode-score";

type EpisodeRowsProps =
  | { readonly rows: readonly EpisodeTableRow[]; readonly kind: "member" }
  | {
      readonly rows: readonly LeagueEpisodeTableRow[];
      readonly kind: "league";
    };

export function EpisodeRows({ rows, kind }: EpisodeRowsProps) {
  return (
    <>
      <div {...stylex.props(styles.wide)}>
        <div {...stylex.props(styles.grid, styles.header)}>
          <span>Episode</span>
          <span>When</span>
          <span>{kind === "member" ? "Result" : "Top seat"}</span>
          {kind === "member" ? (
            <span {...stylex.props(styles.end, localStyles.nowrap)}>
              Score{" "}
              <span {...stylex.props(localStyles.normalWeight)}>
                · vs median
              </span>
            </span>
          ) : (
            <span {...stylex.props(styles.end)}>Score</span>
          )}
          <span />
        </div>
        {rows.map((row) => (
          <div
            key={row.episodeId}
            data-testid={
              kind === "member" ? "episode-row-wide" : "league-episode-row"
            }
            {...stylex.props(styles.grid, styles.row)}
          >
            <span title={row.episodeId} {...stylex.props(styles.id)}>
              {row.episodeId.slice(0, 8)}
            </span>
            <span {...stylex.props(styles.time)}>{row.when}</span>
            <EpisodeResult row={row} />
            <EpisodeScore row={row} />
            <div {...stylex.props(styles.end)}>
              <EpisodeActions row={row} />
            </div>
          </div>
        ))}
      </div>
      <div {...stylex.props(styles.narrow)}>
        {rows.map((row) => (
          <div
            key={row.episodeId}
            data-testid={kind === "member" ? "episode-row-narrow" : undefined}
            {...stylex.props(styles.row, styles.narrowRow)}
          >
            <div {...stylex.props(styles.line)}>
              <span title={row.episodeId} {...stylex.props(styles.id)}>
                {row.episodeId.slice(0, 8)}
              </span>
              <span {...stylex.props(styles.time)}>{row.when}</span>
              <EpisodeResult row={row} narrow />
            </div>
            <div {...stylex.props(styles.line, styles.bottomLine)}>
              <EpisodeScore row={row} narrow />
              <EpisodeActions row={row} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

const localStyles = stylex.create({
  nowrap: { whiteSpace: "nowrap" },
  normalWeight: { fontWeight: 400 },
});
